module.exports = __webpack_public_path__ + "static/bg01-cc7eedea73b69e09272a74ed73f3e0bc.jpg";